import _ from 'underscore'
import OldReportMediator from './OldReportMediator'
import {ReportType} from './constants'
import ReportPrintableHeadersBuilder from './ReportPrintableHeadersBuilder'
import CostReportEditConfigController from './edit_config_controller/costOfWork/CostReportEditConfigController'

export default function CostReportMediator ()
{
    this.constructor = CostReportMediator;
}

CostReportMediator.prototype = _.create(OldReportMediator.prototype);

CostReportMediator.prototype.init = function ( config )
{
    OldReportMediator.prototype.init.call(this, config);

    return this;
};

CostReportMediator.prototype.getReportType = function()
{
    return ReportType.COST_OF_WORK;
};

CostReportMediator.prototype.initEditConfigController = function( config )
{
    const self = this;
    return new CostReportEditConfigController().init(
            {
                reportAuthorizationInfo: config.reportAuthorizationInfo,
                reportParameters: config.reportParameters,
                users: config.users,
                manageableUsersIds: config.manageableUserIds,
                userGroups: config.userGroups,
                timeZoneGroups: config.timeZoneGroups,
                cpList: config.cpList,
                customersWithMaIds: config.customersWithMaIds,
                projectsWithMaIds: config.projectsWithMaIds,
                changeCallback: function(){ self.changeParametersCallback(); }
            } );
};

CostReportMediator.prototype._populateHeadersArray = function( headersArray ) {
    this.printableHeadersBuilder.addCPSelectionParamsStringToArray( this.reportParameters.customersProjectsSelection, headersArray ); //customers and projects
    this.printableHeadersBuilder.addStaffSelectionParamsToArray( this.reportParameters.userSelection, headersArray ); //staff
};

CostReportMediator.prototype.initPrintableHeadersBuilder = function(config) {
    return new ReportPrintableHeadersBuilder().init({
        users: config.users,
        reportParameters: config.reportParameters,
        cpList: config.cpList,
        isFilteredByAssignments: config.isFilteredByAssignments,
        userGroups: config.userGroups,
        timeZoneGroups: config.timeZoneGroups,
    })
}



// WEBPACK FOOTER //
// ./web/js/reports/CostReportMediator.js